module.exports = __webpack_public_path__ + "img/cancel.c9a77152.svg";